import React, { Suspense, type ComponentType } from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { ThirdPartyLogoProps, ThirdPartyLogoSize } from '@atlassian/logo-third-party/types';

export type BrandIcon = (props?: Pick<ThirdPartyLogoProps, 'size'>) => React.JSX.Element;

/**
 * Keep the gate at the icon export so direct consumers and connector configs agree.
 * Both branches remain lazy; the official component owns its single ADS Tile.
 * Glyphs are decorative: RovoLogo wrappers or the consuming control own their labels.
 */
export function withBrandIcon(
	LegacyIcon: () => React.JSX.Element,
	OfficialIcon: ComponentType<ThirdPartyLogoProps>,
	defaultSize: ThirdPartyLogoSize,
): BrandIcon {
	return function BrandIcon({ size = defaultSize } = {}) {
		if (fg('rovo-search-team-eu-26-brand-icon-library')) {
			return (
				<Suspense fallback={null}>
					<OfficialIcon label="" size={size} />
				</Suspense>
			);
		}
		return <LegacyIcon />;
	};
}
